import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import _ from '@app/utils.js'


_.onElementReady('.field-slider', field => {
  const swiper = new Swiper(field, {
    modules: [Autoplay, Pagination, EffectFade],
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    //autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    fadeEffect: {
      crossFade: true,
    }
  });
})

